import React, { FC } from 'react';

import { YesNoQuestion } from '../YesNoQuestion';
import { BudgetQuestionCodes } from 'modules/budget/data/budgetQuestionCodes';

export const Q12: FC<Record<string, unknown>> = () => (
  <YesNoQuestion question={BudgetQuestionCodes.Q12} />);
